import { Box, Chip, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import Collapse from "@mui/material/Collapse";
import useIsMobile from "components/hooks/useIsMobile";
type Props = {
  suggestions: string[];
  onSelect: (text: string) => void;
  sx?: React.CSSProperties;
};

export default ({ suggestions, onSelect, sx }: Props) => {
  const isMobile = useIsMobile();
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    if (!visible && suggestions.length) {
      setVisible(true);
    }
  }, [suggestions]);
  return (
    <Collapse in={visible && !!suggestions.length}>
      <Box
        display="flex"
        sx={{
          flexDirection: "row",
          gap: "6px",
          flexWrap: "nowrap",
          overflow: isMobile ? "auto" : "hidden",
          textOverflow: "ellipsis",
          marginBottom: "-10px",
          marginTop: "12px",
          padding: "0 16px",
          width: isMobile ? "100%" : "auto",
          ...sx,
        }}
      >
        {suggestions.map((suggestion, idx) => {
          const shouldShowTooltip = suggestion.length > 10;
          return (
            <Tooltip
              title={shouldShowTooltip ? suggestion : ""}
              key={idx}
              placement="top"
            >
              <Chip
                sx={{
                  minWidth: "45px",
                  padding: "16px 0px",
                  flex: isMobile ? "0 0 auto" : "1 1 auto", // grow | shrink | basis
                  overflow: isMobile ? "visible" : "hidden",
                  textOverflow: isMobile ? "visible" : "ellipsis",
                  whiteSpace: "nowrap",
                  backgroundColor: "#FFF",
                  borderColor: "#D0D5DD",
                  cursor: "pointer",
                }}
                label={suggestion}
                variant="outlined"
                onClick={() => {
                  onSelect(suggestion);
                  setVisible(false);
                }}
              />
            </Tooltip>
          );
        })}
      </Box>
    </Collapse>
  );
};
